export const resizeImageComparison4 = () => {
    $( ".block_comparison_4 .inner_item .after" ).each(function(){
        let h = $(this).siblings('.before').height();
        $(this).css('min-height', h);
    })
}
